export interface ColumnGroupConfiguration {
  title: string;
  headerClass: string;
  columnMenu: boolean;
}